<template>

<div class="menu" v-on:mouseleave="onMouseLeave">

	<com-context />

	<com-item route="Categories" icon="categories" text="Categories" v-if="$permission('categories', 'read')" />
	<com-item route="Groups" icon="groups" text="Groups" v-if="$permission('groups', 'read')" />
	<com-item route="Items" icon="items" text="Items" v-if="$permission('items', 'read')" />
	<com-item route="Locations" icon="locations" text="Locations" v-if="$permission('locations', 'read')" />
	<com-item route="Templates" icon="texts" text="Templates" v-if="$permission('templates', 'read')" />
	<com-item route="Terms" icon="terms" text="Terms" v-if="$permission('terms', 'read')" />

	<div class="more" :class="{'is-active': is.more}" v-if="$permission(['requests', 'embed', 'share', 'access', 'settings'], 'full')">

		<com-item icon="ellipsis" text="More" v-on:click="onMoreClick" />

		<template v-if="is.more">
			<com-item route="Requests" icon="request" text="Requests" v-if="$permission('requests', 'full')" />
			<com-item route="Embed" icon="embed" text="Embed" v-if="$permission('embed', 'full')" />
			<com-item route="Share" icon="share" text="Share" v-if="$permission('share', 'full')" />
			<com-item route="Accesses" icon="access" text="Access" v-if="$permission('access', 'full')" />
			<com-item route="Settings" icon="settings" text="Settings" v-if="$permission('settings', 'full')" />
		</template>

	</div>

	<com-divide />

	<com-item route="Logout" icon="logout" text="Logout" />

</div>

</template>

<script>

export default {

	components: {
		'com-context': () => import('./menu/Context'),
		'com-item': () => import('./menu/Item'),
		'com-divide': () => import('./menu/Divide')
	},

	data: function() {

		return {
			is: {
				more: false
			}
		}

	},

	methods: {

		onMoreClick: function() {

			this.is.more = !this.is.more

		},

		onMouseLeave: function() {

			this.is.more = false

		}

	}

}

</script>

<style scoped>

.menu {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 64px;
	bottom: 0px;
	background-color: #0b234e;
	display: flex;
	flex-direction: column;
	z-index: 3;
	overflow: hidden;
}

.menu:hover {
	width: 196px;
}

.more.is-active {
	background-color: rgba(255, 255, 255, 0.15);
}

</style>
